import { useMemo } from "react";
import { useSeo } from "@/hooks/useSeo";
import { films } from "@/mocks/films";
import { newsList } from "@/mocks/news";
import HeroCarousel from "@/pages/home/components/HeroCarousel";
import SearchBanner from "@/pages/home/components/SearchBanner";
import CategoryQuickNav from "@/pages/home/components/CategoryQuickNav";
import LatestFilms from "@/pages/home/components/LatestFilms";
import HotFilms from "@/pages/home/components/HotFilms";
import NewsPreview from "@/pages/home/components/NewsPreview";
import SiteIntro from "@/pages/home/components/SiteIntro";

export default function Home() {
  useSeo({
    title: "顽皮的女朋友-精彩影视内容大全与剧情资讯",
    description:
      "顽皮的女朋友网站提供丰富的影视内容，包括影片介绍、剧情资讯和相关剧集推荐，满足用户对《顽皮的女朋友》及相关影视作品的全面了解需求。",
    keywords: "顽皮的女朋友,影视内容,剧情介绍,影视推荐,影视资讯,电影,电视剧,影视作品",
  });

  const featuredFilms = useMemo(() => films.filter((film) => film.featured), []);

  const latestFilms = useMemo(
    () =>
      [...films]
        .sort((a, b) => b.releaseDate.localeCompare(a.releaseDate))
        .slice(0, 8),
    []
  );

  const hotFilms = useMemo(
    () => [...films].sort((a, b) => b.heat - a.heat).slice(0, 6),
    []
  );

  const latestNews = useMemo(
    () => [...newsList].sort((a, b) => b.date.localeCompare(a.date)),
    []
  );

  return (
    <>
      <HeroCarousel films={featuredFilms} />
      <SearchBanner />
      <CategoryQuickNav />
      <LatestFilms films={latestFilms} />
      <HotFilms films={hotFilms} />
      <NewsPreview news={latestNews} />
      <SiteIntro />
    </>
  );
}